export default __webpack_public_path__ + "static/media/users.fe18bfdd.svg";